export default __webpack_public_path__ + "static/media/location.d14b7d67.jpg";